import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import ConfirmationButton from '../../../app/components/ConfirmationButton';

export const EmailResendLink = (props: {
  emailId: string;
  setRefresh?: () => void;
  setLoading?: (loading: boolean) => void;
}) => {
  const spd = useSpdCore();

  const handleClick = () => {
    if (props.setLoading) {
      props.setLoading(true);
    }
    spd.emails
      .resend(props.emailId)
      .then(() => {
        if (props.setRefresh) {
          props.setRefresh();
        }
        if (props.setLoading) {
          props.setLoading(false);
        }
      })
      .catch(error => {
        console.log(
          `Wystąpił problem z ponownym wysłaniem wiadomości e-mail. ${error}`,
        );
        if (props.setLoading) {
          props.setLoading(false);
        }
      });
  };

  return (
    <>
      <ConfirmationButton
        className="ms-1"
        confirmation="Czy na pewno ponownie wysłać wiadomość e-mail?"
        variant="btn-info"
        onOK={handleClick}
      >
        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: 'fixed' }}>Ponowne wysłanie</Tooltip>
          }
        >
          <Icon.ArrowClockwise />
        </OverlayTrigger>
      </ConfirmationButton>
    </>
  );
};
